module.exports = __webpack_public_path__ + "img/towfiqu-barbhuiya-5u6bz2tYhX8-unsplash.cd76a1e2.jpg";